// Google Analytics 4, Consent Mode BASIC: il tag si carica solo dopo il consenso alle statistiche.
const ID = process.env.REACT_APP_GA_ID;
const CONSENT_KEY = "lumacofono_teorie_consenso_statistiche";
const DEBUG_KEY = "lumacofono_teorie_ga_debug";
const listeners = new Set();
let loaded = false;
let prefsOpen = false;

const debug = (() => {
  try {
    if (new URLSearchParams(window.location.search).get("ga_debug") === "1") sessionStorage.setItem(DEBUG_KEY, "1");
    return sessionStorage.getItem(DEBUG_KEY) === "1";
  } catch {
    return false;
  }
})();
const host = window.location.hostname;
const excluded = /^(localhost|127\.0\.0\.1)$/.test(host) || /(^|\.)(emergentagent\.com|emergent\.host)$/.test(host);
export const analyticsAvailable = !!ID && (!excluded || debug);

const disableFlag = `ga-disable-${ID}`;
function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}
const notify = () => listeners.forEach((f) => f());

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

function load() {
  if (!analyticsAvailable || /session_id=/.test(window.location.hash)) return;
  window[disableFlag] = false;
  if (loaded) {
    gtag("consent", "update", { analytics_storage: "granted" });
    return;
  }
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  gtag("consent", "update", { analytics_storage: "granted" });
  gtag("set", { allow_google_signals: false, allow_ad_personalization_signals: false });
  gtag("js", new Date());
  gtag("config", ID, { cookie_domain: host, ...(debug ? { debug_mode: true } : {}) });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`;
  document.head.appendChild(s);
}

function revoke() {
  window[disableFlag] = true;
  if (loaded) gtag("consent", "update", { analytics_storage: "denied" });
  const names = ["_ga", `_ga_${ID.replace(/^G-/, "")}`];
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => names.includes(n)).forEach((n) => {
    ["", host, `.${host}`].forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/${d ? `; domain=${d}` : ""}`; });
  });
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // scelta valida solo per questa visita
  }
  prefsOpen = false;
  if (value === "granted") load(); else revoke();
  notify();
}

export const initAnalytics = () => { if (getConsent() === "granted") load(); };
export const bannerVisible = () => analyticsAvailable && (prefsOpen || !getConsent());
export const openPreferences = () => { prefsOpen = true; notify(); };
export const onConsentChange = (f) => { listeners.add(f); return () => listeners.delete(f); };

export function track(name, params) {
  if (loaded && !window[disableFlag] && getConsent() === "granted") gtag("event", name, params);
}
